module.exports = __webpack_public_path__ + "static/media/icon-trash.e6887622.svg";